const IS_DEBUG_MODE = import.meta.env.NODE_ENV === 'development' || import.meta.env.VITE_DEBUG === 'true';

/**
 * Logs message and given arguments if debug mode is enabled
 * @param message - The message to log
 * @param args - Additional arguments to log
 */
const log = (message: string, ...args: unknown[]): void => {
    const d = new Date();
    const h = (d.getHours() < 10 ? '0' : '') + d.getHours();
    const m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
    const s = (d.getSeconds() < 10 ? '0' : '') + d.getSeconds();
    const timestamp = h + ':' + m + ':' + s;
    if (IS_DEBUG_MODE) {
        console.log(`[${timestamp}] - ${message}`, ...args);
    }
};

const logGroup = (message: string, ...args: unknown[]): void => {
    if (IS_DEBUG_MODE) {
        console.group(message, ...args);
    }
};

const logGroupEnd = (): void => {
    if (IS_DEBUG_MODE) {
        console.groupEnd();
    }
};

export { log, logGroup, logGroupEnd };
